/**
 * See the NOTICE file distributed with this work for additional information
 * regarding copyright ownership.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import classNames from 'classnames';

import SearchIcon from 'static/icons/icon_search.svg';

import styles from './SearchButton.module.css';

type Props = {
  onClick: () => void;
  label: string;
  className?: string;
};

const SearchButton = (props: Props) => {
  const componentClasses = classNames(styles.searchButton, props.className);

  return (
    <button onClick={props.onClick} className={componentClasses}>
      <span>{props.label}</span>
      <span className={styles.searchIconWrapper}>
        <SearchIcon className={styles.searchIcon} />
      </span>
    </button>
  );
};

export default SearchButton;
